.container {
  display: flex;
  flex-direction: row;

  min-height: 100vh;
}

.main {
  flex: 1;
  padding: 2rem;
  background-color: var(--static-background-standard);
  max-width: 40rem;
}

.header {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
}
.logo {
  color: var(--primary-enabled);
}
.aside {
  flex: 1;
  padding: 2rem;

  display: flex;
  align-items: center;
  justify-content: center;

  background: var(--signup-background);
}
